export default "__VITE_ASSET__DuWrtl9N__"